// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArGm_XiS-boJcJLD5HHf6hsbvJjSpCeCo",
  authDomain: "chandler-crane-website.firebaseapp.com",
  projectId: "chandler-crane-website",
  storageBucket: "chandler-crane-website.appspot.com",
  messagingSenderId: "249377803526",
  appId: "1:249377803526:web:e8af2f52befbf9aa136287",
  measurementId: "G-0Q1N78EYLP",
  databaseURL: "https://https://chandler-crane-website-default-rtdb.firebaseio.com",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export const db = getFirestore(app);
